import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import failedIcon from "../../assets/images/failed-icon.svg";
import successIcon from "../../assets/images/success-icon.svg";
import { useStore } from "../../context/StoreContext";
import OrderDetails from "../ViewOrder";
import {
  FINIX_ERROR_MESSAGES,
  GOOGLE_RECAPTCHA_ERROR_MESSAGES,
} from "../../utilities/constant";

const ALL_ERROR_MESSAGES = {
  ...GOOGLE_RECAPTCHA_ERROR_MESSAGES,
  ...FINIX_ERROR_MESSAGES,
};

const OrderFailure = ({ setShowError, errorCode }) => {
  const [successOrders, setSuccessOrders] = useState([]);
  const [failedOrders, setFailedOrders] = useState([]);
  const [orderId, setOrderId] = useState(null);
  const { storeOrderStatus } = useStore();

  return (
    <div className="p-4 mt-8">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-4">
          <div className="bg-white border border-gray-200 rounded-lg p-6 text-center">
            <img
              src={failedIcon}
              alt="Failed"
              className="h-12 w-12 mx-auto mb-4"
            />
            <h2 className="text-2xl font-semibold mb-2">
              Oh no, order couldn't be processed
            </h2>
            <p className="text-gray-600">
              {ALL_ERROR_MESSAGES[errorCode]
                ? ALL_ERROR_MESSAGES[errorCode]
                : ALL_ERROR_MESSAGES["DEFAULT"]}
            </p>
            <button
              onClick={() => setShowError(false)}
              type="submit"
              className="w-[200px] mt-12 bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-4 rounded-full transition duration-300"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderFailure;
